/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { FormattedMessage } from 'react-intl-next';
import { toolbarMessages } from '@atlaskit/editor-common/messages';
import { expandIconContainerStyle, wrapperStyle } from '@atlaskit/editor-common/styles';
import { ToolbarButton } from '@atlaskit/editor-common/ui-menu';
import TextStyleIcon from '@atlaskit/icon/core/migration/text-style--editor-text-style';
import TextIcon from '@atlaskit/icon/core/text';
import ChevronDownIcon from '@atlaskit/icon/utility/migration/chevron-down';
import { fg } from '@atlaskit/platform-feature-flags';
import { NORMAL_TEXT } from '../../block-types';
import { buttonContentReducedSpacingStyle, buttonContentStyle, wrapperSmallStyle } from './styled';
export var BlockTypeButton = function BlockTypeButton(props) {
  var blockTypeName = props.blockTypeName || '';
  var labelTextStyles = props.formatMessage(toolbarMessages.textStyles, {
    blockTypeName: blockTypeName
  });
  var toolipTextStyles = props.formatMessage(toolbarMessages.textStylesTooltip);
  return jsx(ToolbarButton, {
    spacing: props.isReducedSpacing ? 'none' : 'default',
    selected: props.selected
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: "block-type-btn",
    disabled: props.disabled,
    onClick: props.onClick,
    onKeyDown: props.onKeyDown,
    title: toolipTextStyles,
    "aria-label": labelTextStyles,
    "aria-haspopup": true,
    "aria-expanded": props['aria-expanded'],
    iconAfter: jsx("span", {
      // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      css: [wrapperStyle, props.isSmall && wrapperSmallStyle],
      "data-testid": "toolbar-block-type-text-styles-icon"
    }, jsx(React.Fragment, null, props.isSmall && (
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
    fg('platform.design-system-team.enable-new-icons') ? jsx(TextIcon, {
      label: labelTextStyles,
      spacing: "spacious",
      color: "currentColor"
    }) : jsx(TextStyleIcon, {
      color: "currentColor",
      spacing: "spacious",
      label: labelTextStyles
    })), jsx("span", {
      // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      css: expandIconContainerStyle
    }, jsx(ChevronDownIcon, {
      label: "",
      color: "currentColor",
      LEGACY_margin: "0 0 0 -8px"
    }))))
  }, !props.isSmall && jsx("span", {
    css: [
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    buttonContentStyle,
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    props.isReducedSpacing && buttonContentReducedSpacingStyle]
  }, jsx(FormattedMessage, props.title || NORMAL_TEXT.title)));
};